exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".videoContainer[data-v-8d1d7f5c]{position:absolute;top:0;left:0;width:100vw;height:100vh;overflow:hidden;z-index:50000}", ""]);

// exports
